import axios from "axios";
import { Message } from "element-ui";

/** 避免：页面通过公网/局域网访问时仍写死 http://localhost:8080，浏览器会连「用户自己电脑」导致 Network Error */
function resolveBaseURL() {
  let base = process.env.VUE_APP_BASE_URL || "/api";
  base = String(base).replace(/^['"]|['"]$/g, "");
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const pageIsOnDevMachine =
      host === "localhost" || host === "127.0.0.1" || host === "[::1]";
    const pointsToLoopbackBackend = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(
      base
    );
    if (!pageIsOnDevMachine && pointsToLoopbackBackend) {
      return "/api";
    }
  }
  return base;
}

// 创建axios实例
const service = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 5000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    //添加token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res && res.code !== 200) {
        // token 失效（后端返回 200 + 业务码的情况），清除并跳转登录
        if (res.code === 401 || (res.message && (res.message.indexOf('token') !== -1 || res.message.indexOf('登录') !== -1))) {
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          Message({ message: '登录已过期，请重新登录', type: 'warning', duration: 2000 });
          setTimeout(() => { window.location.href = '/login'; }, 500);
          return Promise.reject('登录已过期');
        }
        //消息提示
        Message({
          message: res.message,
          type: "error",
          duration: 3 * 1000,
        });
      return Promise.reject(res.message);
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    // HTTP 401 — 后端明确返回 401 状态码，清除 token 跳转登录
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      Message({ message: '登录已过期，请重新登录', type: 'warning', duration: 2000 });
      setTimeout(() => { window.location.href = '/login'; }, 500);
      return Promise.reject('登录已过期');
    }
    // 其他 HTTP 错误（网络断开、500 等）
    Message({
      message: error.message || '请求失败，请检查网络',
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

// 导出实列
export default service;